import { cn } from "@/lib/utils";
import { m } from "@/paraglide/messages";
import { NoDataIcon } from "~/components/icons";

export default function Nodata({ className }: { className?: string }) {
	return (
		<div
			className={cn(
				"flex flex-col justify-center items-center h-full py-20",
				className,
			)}
		>
			<NoDataIcon />
			<p className="text-t3 text-sm font-medium mb-3">
				<m.common_nodata />
			</p>
		</div>
	);
}
